import { Card } from "../../../app/components/primitives/card";
import { Button } from "../../../app/components/primitives/button";
import { PortalSignInShell } from "./PortalSignInShell";

/** The wait while the portal asks the server who the signed-in person is: shared by the landing gate and the outcome pages. */
export function PortalSignInLoading({ footer }: { footer?: React.ReactNode }) {
  return (
    <PortalSignInShell title="One moment" footer={footer}>
      <Card className="p-5 text-center text-sm text-muted-foreground">
        Checking your details…
      </Card>
    </PortalSignInShell>
  );
}

/** The server could not be reached, or answered something unexpected. Says so plainly and offers the retry. */
export function PortalSignInFailed({ onRetry }: { onRetry: () => void }) {
  return (
    <PortalSignInShell title="Something went wrong">
      <Card className="items-center gap-3 p-5 text-center">
        <p className="text-sm text-muted-foreground">
          We couldn&apos;t check your details just now.
        </p>
        <Button variant="outline" onClick={onRetry}>
          Try again
        </Button>
      </Card>
    </PortalSignInShell>
  );
}
